import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import PageContainer from "../../Components/PageContainer";
import Logs from "./Logs";

const LogsMain = () => {
  const [page, setPage] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPage(0);
  };

  // Define the categories for the tabs
  const categories = [
    { label: "PAN", key: "pan" },
    { label: "Aadhaar", key: "aadhar" },
    { label: "Voter ID", key: "voterid" },
    { label: "Account Aggregator", key: "accountaggregator" },
    { label: "Penny Drop", key: "pennydrop" },
  ];

  return (
    <PageContainer heading={"Logs"}>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          {categories.map((category, index) => (
            <Tab key={index} label={category.label} />
          ))}
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{ p: 3 }}>
        {/* Render Logs component with a filter based on the selected tab */}
        <Logs type={categories[activeTab].key} setPage={setPage} page={page} />
      </Box>
    </PageContainer>
  );
};

export default LogsMain;
